// The "All" date range's start. It is the day the account was created (authData.createdAt) when the account has one; an account record without a usable date (a demo, a local test user created without
// timestamps) used to show "Invalid Date - Today" and ask for the range from "Invalid Date". Now it says "All time" and asks from the beginning of time, which means the same.

/** a real Date for what the account holds, or null when it holds nothing usable */
export const accountStartDate = (createdAt: unknown): Date | null => {
  if (createdAt === undefined || createdAt === null || createdAt === "") return null;
  const date = new Date(createdAt as string | number | Date);

  return Number.isFinite(date.getTime()) ? date : null;
};

/** the "All" range's own value: the account's start, or the very beginning (every visit there is) when the account has none */
export const allRangeValue = (createdAt: unknown): Date => accountStartDate(createdAt) ?? new Date(0);

/** what the range button says: "Oct 24, 2026 - Today", or "All time" when there is no start to name */
export const allRangeLabel = (createdAt: unknown): string => {
  const start = accountStartDate(createdAt);

  return start ? `${start.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })} - Today` : "All time";
};
